import React, { useContext, useEffect, useState } from "react";
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  Box,
  StepConnector,
} from "@mui/material";
import StoreDetails from "./Steppers/StoreDetails";
import AddProductButton from "./Steppers/AddProductButton";
import Shipment from "./Steppers/Shipment";
import {
  addDoc,
  collection,
  doc,
  serverTimestamp,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../../firebaseConfig";
import { v4 as uuidv4 } from "uuid";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import StoreStepperContext from "../../../context/storeStepperContext";
import { useSelector } from "react-redux";

const steps = [
  { label: "Store Details" },
  { label: "Catalogues" },
  { label: "Shipments" },
];

function AddStoreStepper() {
  const {
    storeformData,
    setStoreFormData,
    stepperActiveStep,
    setStepperActiveStep,
    saveContinueBtn,
    setSaveContinueBtn,
    setProducts,
  } = useContext(StoreStepperContext);
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.value);

  useEffect(() => {
    const redirectStep = sessionStorage.getItem("stepperRedirectStep");
    if (redirectStep) {
      setStepperActiveStep(parseInt(redirectStep, 10));
      sessionStorage.removeItem("stepperRedirectStep");
    }
  }, []);

  function getStepContent(step) {
    switch (step) {
      case 0:
        return <StoreDetails />;
      case 1:
        return <AddProductButton />;
      case 2:
        return <Shipment />;
      default:
        return <StoreDetails />;
    }
  }

  // const submitStepOneData = async () => {
  //   const apiData = {
  //     storeID: storeformData.storeID ? storeformData.storeID : uuidv4(),
  //     storeName: storeformData.storeName ? storeformData.storeName : "",
  //     storeLocation: storeformData.storeLocation
  //       ? storeformData.storeLocation
  //       : "",
  //     storeState: storeformData.storeState ? storeformData.storeState : "",
  //     storeCity: storeformData.storeCity ? storeformData.storeCity : "",
  //     ...(storeformData?.storeImages?.length > 0 && {
  //       storeImages: storeformData.storeImages,
  //     }),
  //     storeDesignation: storeformData?.storeDesignation,
  //     storeCurrency: storeformData?.storeCurrency,
  //     storeWeight: storeformData?.storeWeight,
  //     storeDescription: storeformData.storeDescription
  //       ? storeformData.storeDescription
  //       : "",
  //     storeShipment: storeformData?.shipment ? storeformData?.shipment : "",
  //     storeCreatedDate: new Date(),
  //     products: storeformData?.products?.map((product, index) => ({
  //       storeID: storeformData.storeID ? storeformData.storeID : uuidv4(),
  //       ...(storeformData?.storeImages?.length > 0 && {
  //         storeImages: storeformData.storeImages,
  //       }),
  //       productId: product.productId ? product.productId : uuidv4(),
  //       productBrand: product.productBrand ? product.productBrand : "",
  //       productCategory: product.productCategory ? product.productCategory : "",
  //       productImage: product.productImage ? product.productImage : "",
  //       productDescription: product.productDescription
  //         ? product.productDescription
  //         : "",
  //       productDimentionH: product.productDimentionH
  //         ? product.productDimentionH
  //         : 0,
  //       productDimentionL: product.productDimentionL
  //         ? product.productDimentionL
  //         : 0,
  //       productDimentionW: product.productDimentionW
  //         ? product.productDimentionW
  //         : 0,
  //       productKeyFeatures: product.productKeyFeatures
  //         ? product.productKeyFeatures
  //         : "",
  //       productUseCase: product.productUseCase
  //         ? product.productUseCase
  //         : "",
  //       productBenefits: product.productBenefits
  //         ? product.productBenefits
  //         : "",
  //       productNutritionalValue: product.productNutritionalValue
  //         ? product.productNutritionalValue
  //         : "",
  //       productProductSpecifications: product.productProductSpecifications
  //         ? product.productProductSpecifications
  //         : "",
  //       productTagretAudience: product.productTagretAudience
  //         ? product.productTagretAudience
  //         : "",
  //       productName: product.productName ? product.productName : "",
  //       productPrice: product.productPrice ? product.productPrice : 0,
  //       productStock: product.productStock ? product.productStock : 0,
  //       productTag: product.productTags ? product.productTags : "",
  //       productWeight: product.productWeight ? product.productWeight : 0,
  //       productVarient: product.productVarient ? product.productVarient : [],
  //       productStatus: user?.role === "Superadmin" ? true : false,
  //       productUnderReview: false,
  //     })),
  //   };
  //   // Reference the "stores" collection
  //   const storesCollectionRef = collection(db, "stores");
  //   const docRef = await addDoc(storesCollectionRef, apiData);

  //   // Add products to "productMasterList" using productId as doc id
  //   const productMasterListRef = collection(db, "productMasterList");

  //   const addProductsPromises = apiData.products.map((product) =>
  //     setDoc(doc(productMasterListRef, product.productId), product)
  //   );
  //   await Promise.all(addProductsPromises);

  //   setStoreFormData({
  //     storeID: uuidv4(),
  //     storeName: "",
  //     storeLocation: "",
  //     storeDescription: "",
  //     storeImages: [],
  //     storeShipment: "",
  //     storeDesignation: [],
  //     storeCreatedDate: new Date(),
  //     products: [],
  //   });
  //   setStepperActiveStep(0);
  //   toast.success(`Store added successfully`);
  //   navigate("/shopping/store");
  // };

  const submitStepOneData = async () => {
    // Build the apiData object
    const apiData = {
      storeID: storeformData.storeID || uuidv4(),
      storeName: storeformData.storeName || "",
      storeLocation: storeformData.storeLocation || "",
      storeState: storeformData.storeState || "",
      storeCity: storeformData.storeCity || "",
      storeImages:
        storeformData?.storeImages?.length > 0 ? storeformData.storeImages : [],
      storeDesignation: storeformData?.storeDesignation || [],
      storeCurrency: storeformData?.storeCurrency || "",
      storeWeight: storeformData?.storeWeight || "",
      storeDescription: storeformData.storeDescription || "",
      storeShipment: storeformData?.shipment || "",
      storeCreatedDate: new Date(),
      products:
        storeformData?.products?.map((product, index) => ({
          storeID: storeformData.storeID || uuidv4(),
          storeImages:
            storeformData?.storeImages?.length > 0
              ? storeformData.storeImages
              : [],
          productId: product.productId || uuidv4(),
          productBrand: product.productBrand || "",
          productCategory: product.productCategory || "",
          productImage: product.productImage || "",
          productDescription: product.productDescription || "",
          productDimentionH: product.productDimentionH || 0,
          productDimentionL: product.productDimentionL || 0,
          productDimentionW: product.productDimentionW || 0,
          productKeyFeatures: product.productKeyFeatures || "",
          productUseCase: product.productUseCase || "",
          productBenefits: product.productBenefits || "",
          productNutritionalValue: product.productNutritionalValue || "",
          productProductSpecifications:
            product.productProductSpecifications || "",
          productTagretAudience: product.productTagretAudience || "",
          productName: product.productName || "",
          productPrice: product.productPrice || 0,
          productStock: product.productStock || 0,
          productTag: product.productTags || "",
          productWeight: product.productWeight || 0,
          productVarient: product.productVarient || [],
          productStatus: user?.role === "Superadmin" ? true : false,
          productType: product?.productType || false,
          productUnderReview: false,
          parcelName: product.parcelName || "",
          parcelProducts: product.parcelProducts || [],
          price: product.price || "",
          quantity: product.quantity || "",
          weight: product.weight || "",
          parcelSize: product.parcelSize || [],
        })) || [],
    };

    try {
      // Reference the "stores" collection
      const storesCollectionRef = collection(db, "stores");

      // Add store to Firestore
      const docRef = await addDoc(storesCollectionRef, apiData);

      // Add products to "productMasterList"
      const productMasterListRef = collection(db, "productMasterList");

      const addProductsPromises = apiData.products.map((product) =>
        setDoc(doc(productMasterListRef, product.productId), product)
      );

      await Promise.all(addProductsPromises);

      // Reset form data and stepper
      setStoreFormData({
        storeID: uuidv4(),
        storeName: "",
        storeLocation: "",
        storeDescription: "",
        storeImages: [],
        storeShipment: "",
        storeDesignation: [],
        storeCreatedDate: new Date(),
        products: [],
      });
      setStepperActiveStep(0);
      toast.success(`Store added successfully`);
      navigate("/shopping/store");
      setProducts([]);
    } catch (error) {
      console.error("%cError adding store or products: ", "color:red", error);
      toast.error("Failed to add store. Please try again.");
    }
  };

  const handleNext = () => {
    if (stepperActiveStep === 0 && storeformData?.storeName === "") {
      toast.error("Please enter store name");
      return;
    }
    if (user?.role !== "Superadmin") {
      if (stepperActiveStep === 0 && storeformData?.storeCurrency === "") {
        toast.error("Please enter store currency");
        return;
      }
      if (stepperActiveStep === 0 && storeformData?.storeWeight === "") {
        toast.error("Please enter store weight");
        return;
      }
    }
    if (stepperActiveStep === 1) {
      setStepperActiveStep((prevActiveStep) => prevActiveStep + 1);
      return;
    } else if (stepperActiveStep === 2) {
      submitStepOneData();
    } else {
      setStepperActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    setStepperActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleReset = () => {
    setStepperActiveStep(0);
  };

  return (
    <Box
      sx={{
        margin: "0 auto",
        padding: "20px",
        backgroundColor: "white",
      }}
    >
      <Box
        sx={{
          borderBottom: "1px solid rgba(229, 229, 232, 1)",
        }}
      >
        <Stepper
          activeStep={stepperActiveStep}
          alternativeLabel
          sx={{
            width: "50%", // Set the Stepper width to 50%
            margin: "0 auto", // Center the Stepper
            paddingBottom: 3,
          }}
        >
          {steps.map((step, index) => (
            <Step key={step.label}>
              <StepLabel
                StepIconProps={{
                  sx: {
                    "&.MuiStepIcon-root": {
                      color: "#FFF",
                      border: "1px solid",
                      borderRadius: "100%",
                      borderColor: "#959BA1",
                    },
                    "& .MuiStepIcon-text": {
                      fill: "#959BA1",
                      fontWeight: 600,
                    },
                    "&.Mui-completed": {
                      color: "#38A34F",
                      borderColor: "#38A34F",
                    },
                    "&.Mui-active": {
                      color: "white",
                      border: "1px solid",
                      borderRadius: "100%",
                      borderColor: "#F68712",
                      "& .MuiStepIcon-text": {
                        fill: "#F68712",
                        color: "#FFF",
                        fontWeight: "bold",
                      },
                    },
                  },
                }}
              >
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 600,
                    color: "rgba(28, 38, 48, 1)",
                    lineHeight: "14px",
                  }}
                >
                  {step.label}
                </span>
              </StepLabel>
              {index > 0 && (
                <StepConnector
                  sx={{
                    "& .MuiStepConnector-line": {
                      borderWidth: "1px",
                      borderColor:
                        index < stepperActiveStep ? "#38A34F" : "#EDEDED",
                    },
                  }}
                />
              )}
            </Step>
          ))}
        </Stepper>
      </Box>
      <Box>
        {stepperActiveStep === steps.length ? (
          <Box>
            <Typography>All steps completed</Typography>
            <Button onClick={handleReset}>Reset</Button>
          </Box>
        ) : (
          <Box>
            <Box
              sx={{
                borderBottom: "1px solid rgba(229, 229, 232, 1)",
              }}
            >
              {getStepContent(stepperActiveStep)}
            </Box>
            <Box
              sx={{
                position: "absolute",
                bottom: "3%",
                right: "5%",
              }}
            >
              <Button
                variant="contained"
                disabled={stepperActiveStep === 0}
                sx={{
                  backgroundColor: "#fff",
                  color: "black",
                  width: "155px",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                  marginTop: "20px",
                  marginRight: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "black",
                    backgroundColor: "#fff",
                  },
                }}
                onClick={handleBack}
              >
                Back
              </Button>
              <Button
                variant="contained"
                id="SaveContinueBtn"
                sx={{
                  backgroundColor: "#5E17EB",
                  width: "155px",
                  color: "#fff",
                  border: "1px solid #5E17EB",
                  borderRadius: "4px",
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                  marginTop: "20px",
                  "&:hover": {
                    outline: "none",
                    color: "#fff",
                    backgroundColor: "#5E17EB",
                  },
                }}
                onClick={() => {
                  if (
                    saveContinueBtn === false &&
                    storeformData?.products?.length > 0
                  ) {
                    setSaveContinueBtn(true);
                  } else {
                    handleNext();
                  }
                }}
              >
                {saveContinueBtn === false &&
                storeformData?.products?.length > 0
                  ? "Save"
                  : "Continue"}
              </Button>
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  );
}

export default AddStoreStepper;
